module.exports = __webpack_public_path__ + "img/223.40a42499.jpg";